import { shoppingCart } from "@/services/shoppingCart";
import { mapState, mapGetters, mapMutations } from "vuex";

export const deliveryOrderMixin = {
  computed: {
    ...mapState('customer', ["supplier","instance", "polygon" ]),
    ...mapState('order', ["service", "subservice","purchaseId","taPurchaseId","countProductsList","shoppingCart"]),
    ...mapState('profile', ["location","session","profile"]),
    ...mapState('shared', ["confirmationLocation"]),
    ...mapState('delivery', ["zone","cutleryStore","packedStore","commentStore"]),
    ...mapGetters('customer', ['getLabels'])
  },
  methods: {
    ...mapMutations('order', ['setShoppingCart']),
    ...mapMutations('shared', ['setOpenValidateCoverge']),
    enableCutlery() {
      if (this.cutleryStore) shoppingCart.modifyCart({ cutlery: this.cutleryStore });
    },
    enablePacked() {
      if (this.packedStore) shoppingCart.modifyCart({ packed: this.packedStore });
    },
    saveComment() {
      if (this.commentStore) shoppingCart.modifyCart({ comment: this.commentStore });
    },
    pay() {
      this.enableCutlery();
      this.enablePacked();
      this.saveComment();
      if (this.supplier.minimum_order_value != null && this.supplier.minimum_order_value > Number(this.shoppingCart.total)) {
        this.error_amount = `${ this.$t("common.min_value_purshase")} ${ this.$n(this.supplier.minimum_order_value,"currency",this.instance.locale) }`;
        return;
      }
      this.error_amount = "";
      this.closeConfirmationLocation();
      if(this.$route.name !== 'Precheckout'){
        this.$router.push({
          name: "Precheckout",
          params: {supplier_id: this.supplier.slug}
        });
      }
    },
    async getShoppingCart() {
      try {
        const response = await shoppingCart.getProductsCart();
        if (response) this.setShoppingCart(response);
      } catch (error) {
        console.error(error);
      }
    },
    closeConfirmationLocation () {
      this.setOpenValidateCoverge(false);
    },
    openValidateCoverge () {
      this.setOpenValidateCoverge(true);
    }
  }
}